﻿import React, { useState, useEffect, useRef } from 'react';
import { parseQueryParams } from '../../../lib/utils';
import '../../../styles/KaylinAnnBirthday.css';
import kaylinPhoto from '../../../assets/images/kaylin-ann/kaylin-ann-picture.webp';
import kaylinCalig from '../../../assets/images/kaylin-ann/kaylin-ann-caligraphy.webp';
import decorSheet from '../../../assets/images/kaylin-ann/kaylin_kuromi_decor_spritesheet.webp';
import logicaLogo from '../../../assets/images/Logica (Black and White).webp';
import kuromSheet from '../../../assets/images/kaylin-ann/kuromi_facecard_spritesheet.webp';
import danceSheet from '../../../assets/images/kaylin-ann/korumi-spritesheet-dance.webp';
import bgMusic   from '../../../assets/sounds/kuromi-background-music.mp3';

/* -- Config ---------------------------------------------------------- */
// TODO: Update to confirmed party date/time
const EVENT_DATE   = new Date('2026-05-23T14:00:00+08:00');
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

const UI_EMOJI = {
  cupcake:   '\u{1F9C1}',
  gift:      '\u{1F381}',
  wish:      '\u{1F48C}',
  bill:      '\u{1F4B5}',
  rose:      '\u{1F339}',
  balloon:   '\u{1F388}',
  lollipop:  '\u{1F36D}',
  sparkle:   '\u2728',
  party:     '\u{1F389}',
  heart:     '\u{1F49C}',
  bow:       '\u{1F380}',
  pin:       '\u{1F4CD}',
  map:       '\u{1F5FA}\uFE0F',
  musicOn:   '\u{1F50A}',
  musicOff:  '\u{1F507}',
  message:   '\u{1F4E8}',
  smile:     '\u{1F60A}',
  celebrate: '\u{1F973}',
  sad:       '\u{1F614}',
};

/* -- Traditions ------------------------------------------------------- */
const TRADITIONS = [
  { id: 'cupcakes',  emoji: UI_EMOJI.cupcake,  label: `${UI_EMOJI.cupcake} Cupcakes`,    names: ['Xab','Sophie','Anica','Kixa','Sophia','Jewel','Joyvelle'] },
  { id: 'gifts',     emoji: UI_EMOJI.gift,     label: `${UI_EMOJI.gift} Gifts`,          names: ['Maiko','Derk Liam','Lhoraine','Ate Paula','Ate Pei','Tita Dindin','Tita Camile'] },
  { id: 'wishes',    emoji: UI_EMOJI.wish,     label: `${UI_EMOJI.wish} Wishes`,         names: ['Lolay Cindy','Lola Connie','Mama Anday','Mamu Perly','Ate Tonet','Ate Sandy','Nanay Linda'] },
  { id: 'bills',     emoji: UI_EMOJI.bill,     label: `${UI_EMOJI.bill} Blue Bills`,     names: ['Ninang Mae','Mommy Jing','Tito Jeric','Tita Gerrylyn','Tita Tampi','Tita Cherry','Tita Eanna'] },
  { id: 'roses',     emoji: UI_EMOJI.rose,     label: `${UI_EMOJI.rose} Roses`,          names: ['Loloy','Lolo Ronald','Lolo Tuper','Tito Ron Ron','Tito Junior','Kuya Thirdy','Daddy Jayar'] },
  { id: 'balloons',  emoji: UI_EMOJI.balloon,  label: `${UI_EMOJI.balloon} Balloons`,    names: ['Zoe','Zian','Accey','Nathan','Chrisha Mae','Maru','Monique'] },
  { id: 'lollipops', emoji: UI_EMOJI.lollipop, label: `${UI_EMOJI.lollipop} Lollipops`,  names: ['Janina','Aeris','Ian','Liam Grabol','Cee-y','Caleb','Alliana'] },
];

/* -- Sparkle dots ----------------------------------------------------- */
const SPARKLES = [
  { left:'8%',  dur:'8s',  delay:'0s',    bg:'rgba(249,184,208,0.85)' },
  { left:'18%', dur:'9s',  delay:'2s',    bg:'rgba(155,93,229,0.75)' },
  { left:'32%', dur:'7s',  delay:'1s',    bg:'rgba(249,184,208,0.85)' },
  { left:'48%', dur:'10s', delay:'4s',    bg:'rgba(255,255,255,0.90)' },
  { left:'68%', dur:'8s',  delay:'1.5s',  bg:'rgba(155,93,229,0.75)' },
  { left:'84%', dur:'9s',  delay:'3s',    bg:'rgba(249,184,208,0.85)' },
];

const CONFETTI_COLORS = ['#e879a0','#9b5de5','#e0c8ff','#ffffff','#1a1a2e'];

/* -- Helpers ---------------------------------------------------------- */
function pad(n) { return String(n).padStart(2,'0'); }

/* -----------------------------------------------------------------------
   COMPONENT
   ----------------------------------------------------------------------- */
export default function KaylinAnnBirthday() {
  const [splashVisible, setSplashVisible] = useState(true);
  const [splashExiting, setSplashExiting] = useState(false);
  const [activeTab,    setActiveTab]      = useState('cupcakes');
  const [countdown,    setCountdown]      = useState({ days:0, hours:0, minutes:0, seconds:0 });
  const [modal,        setModal]          = useState(null);   // { icon, title, text }
  const [rsvpData,     setRsvpData]       = useState({ name:'', status:'', guests:'1', message:'' });
  const [rsvpDone,     setRsvpDone]       = useState(false);
  const [rsvpLoading,  setRsvpLoading]    = useState(false);
  const [rsvpError,    setRsvpError]      = useState('');
  const [musicOn,      setMusicOn]        = useState(false);

  const audioRef         = useRef(null);
  const musicTimerRef    = useRef(null);
  const spriteRef        = useRef(null);
  const heroSpriteRef    = useRef(null);
  const idleTimerRef     = useRef(null);
  const heroIdleTimerRef = useRef(null);
  const openTimerRef     = useRef(null);
  const isOpeningRef     = useRef(false);

  /* -- Countdown ---------------------------------------------------- */
  useEffect(() => {
    const tick = () => {
      const diff = EVENT_DATE - new Date();
      if (diff <= 0) { setCountdown({ days:0, hours:0, minutes:0, seconds:0 }); return; }
      setCountdown({
        days:    Math.floor(diff / 86_400_000),
        hours:   Math.floor((diff % 86_400_000) / 3_600_000),
        minutes: Math.floor((diff % 3_600_000)  / 60_000),
        seconds: Math.floor((diff % 60_000)      / 1_000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  /* -- Cleanup music on unmount ------------------------------------- */
  useEffect(() => () => {
    if (audioRef.current) { audioRef.current.pause(); audioRef.current = null; }
    clearTimeout(idleTimerRef.current);
    clearInterval(heroIdleTimerRef.current);
    clearInterval(openTimerRef.current);
  }, []);

  /* -- Sprite helpers --------------------------------------------- */
  // Hero sprite positions for kuromi_facecard_spritesheet.
  const FRAME_POSITIONS = [
    { x: 0,    y: 0   },  // 0: idle_01
    { x: 362,  y: 0   },  // 1: blink_02
    { x: 724,  y: 0   },  // 2: bounce_03
    { x: 1086, y: 0   },  // 3: happy_04
    { x: 0,    y: 543 },  // 4: wink_05
    { x: 362,  y: 543 },  // 5: excited_06
    { x: 724,  y: 543 },  // 6: magic_07
    { x: 1086, y: 543 },  // 7: settle_08
  ];

  // Splash dance positions for korumi-spritesheet-dance using 280px display cells.
  const S = 280;
  const DANCE_POSITIONS = [
    { x: 0,     y: 0 },  // 0: idle_01
    { x: S,     y: 0 },  // 1: idle_blink_02
    { x: S*2,   y: 0 },  // 2: wand_lift_03
    { x: S*3,   y: 0 },  // 3: jump_04
    { x: 0,     y: S },  // 4: present_05
    { x: S,     y: S },  // 5: magic_sparkle_06
    { x: S*2,   y: S },  // 6: celebrate_07
    { x: S*3,   y: S },  // 7: settle_08
  ];

  const setSpriteFrame = (frameIndex) => {
    if (!spriteRef.current) return;
    const { x, y } = DANCE_POSITIONS[frameIndex];
    spriteRef.current.style.backgroundPosition = `-${x}px -${y}px`;
  };
  const createMiniSparkles = () => {
    for (let i = 0; i < 12; i++) {
      const el = document.createElement('span');
      el.className = 'ka-mini-sparkle';
      el.style.left = `${50 + Math.random() * 30}%`;
      el.style.top  = `${35 + Math.random() * 30}%`;
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 900);
    }
  };

  /* -- Idle blink animation (splash visible, before button click) --- */
  const startIdleAnimation = () => {
    const tick = (isBlinking) => {
      setSpriteFrame(isBlinking ? 1 : 0);
      idleTimerRef.current = setTimeout(() => tick(!isBlinking), isBlinking ? 300 : 2000);
    };
    tick(false);
  };

  useEffect(() => {
    // Check URL params for guestName and guestRole to show greeting
    try {
      const params = parseQueryParams(window.location.search || '');
      const guestName = params.guestName || params.guest || '';
      const guestRole = params.guestRole || params.role || '';
      if (guestName) {
        setModal({
          icon: '🎀',
          title: `You're invited, ${guestName}`,
          text: guestRole ? `Role: ${guestRole}` : 'Welcome — we are glad you can join us!'
        });
      }
    } catch (e) {}
    
    startIdleAnimation();
    return () => {
      clearTimeout(idleTimerRef.current);
      clearInterval(openTimerRef.current);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* -- Hero idle animation (after splash disappears) ----------------- */
  useEffect(() => {
    if (!splashVisible) {
      let toggle = false;
      heroIdleTimerRef.current = setInterval(() => {
        if (!heroSpriteRef.current) return;
        const { x, y } = FRAME_POSITIONS[toggle ? 1 : 0];
        heroSpriteRef.current.style.backgroundPosition = `-${x}px -${y}px`;
        toggle = !toggle;
      }, 900);
      return () => clearInterval(heroIdleTimerRef.current);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splashVisible]);

  /* -- Music helpers ------------------------------------------------ */
  const toggleMusic = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(bgMusic);
      audioRef.current.loop   = true;
      audioRef.current.volume = 0.5;
    }
    if (musicOn) {
      audioRef.current.pause();
      setMusicOn(false);
    } else {
      audioRef.current.play().catch(() => {});
      setMusicOn(true);
    }
  };

  /* -- Confetti ----------------------------------------------------- */
  const launchConfetti = (amount = 42) => {
    for (let i = 0; i < amount; i++) {
      const el = document.createElement('div');
      el.className = 'ka-confetti-piece';
      el.style.left       = `${Math.random() * 100}vw`;
      el.style.background = CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)];
      el.style.animationDelay = `${Math.random() * 0.45}s`;
      el.style.transform  = `rotate(${Math.random() * 180}deg)`;
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 1800);
    }
  };

  /* -- Splash opening animation ----------------------------------- */
  const playOpeningAnimation = () => {
    if (isOpeningRef.current) return;
    isOpeningRef.current = true;
    clearTimeout(idleTimerRef.current);

    // Start background music on user gesture (play for all viewports, including mobile)
    if (!audioRef.current) {
      audioRef.current = new Audio(bgMusic);
      audioRef.current.loop   = true;
      audioRef.current.volume = 0.5;
    }
    audioRef.current.play().catch(() => {});
    setMusicOn(true);

    let frame = 0;
    openTimerRef.current = setInterval(() => {
      setSpriteFrame(frame);
      if (frame === 6) createMiniSparkles();
      frame++;
      if (frame >= 8) {
        clearInterval(openTimerRef.current);
        setTimeout(() => {
          setSplashExiting(true);
          setTimeout(() => setSplashVisible(false), 700);
        }, 500);
      }
    }, 120);
  };

  /* -- Scroll nav --------------------------------------------------- */
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  /* -- Name card click ---------------------------------------------- */
  const showNameModal = (emoji, name) => {
    setModal({ icon: emoji, title: name, text: `Thank you for being part of Kaylin's magical birthday celebration! ${UI_EMOJI.sparkle}` });
    launchConfetti(18);
  };

  /* -- RSVP --------------------------------------------------------- */
  const onRsvpChange = (e) => {
    const { name, value } = e.target;
    setRsvpData(prev => ({ ...prev, [name]: value }));
  };
  const handleRsvpSubmit = async (e) => {
    e.preventDefault();
    if (!rsvpData.name.trim()) { setRsvpError('Please enter your name.'); return; }
    if (!rsvpData.status)      { setRsvpError('Please select your attendance.'); return; }
    setRsvpError('');
    setRsvpLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/rsvp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:         rsvpData.name.trim(),
          attending:    rsvpData.status,
          guests:       Number(rsvpData.guests),
          message:      rsvpData.message.trim(),
          event:        'kaylin-ann-birthday-2026',
          invitationId: 'birthday-kaylin-ann',
        }),
      });
      if (!res.ok) throw new Error('Server error');
      setModal({ icon: UI_EMOJI.party, title: 'RSVP Sent!', text: `Thank you, ${rsvpData.name.trim()}! We can't wait to celebrate with you. ${UI_EMOJI.sparkle}` });
      setRsvpDone(true);
      launchConfetti(55);
    } catch {
      setRsvpError('Oops! Something went wrong. Please try again.');
    } finally {
      setRsvpLoading(false);
    }
  };

  const activeTrad = TRADITIONS.find(t => t.id === activeTab);

  /* -------------------------------------------------------------------
     RENDER
     ------------------------------------------------------------------- */
  return (
    <div className="ka-root" style={{ '--ka-decor': `url(${decorSheet})` }}>

      {/* Sparkle background */}
      <div className="ka-sparkle" aria-hidden="true">
        {SPARKLES.map((s, i) => (
          <span key={i} className="ka-sparkle-dot" style={{
            left: s.left, background: s.bg,
            boxShadow: `0 0 18px ${s.bg}`,
            animationDuration: s.dur, animationDelay: s.delay,
          }} />
        ))}
      </div>

      {/* -- SPLASH --------------------------------------------------- */}
      {splashVisible && (
        <div className={`ka-splash${splashExiting ? ' exiting' : ''}`} role="dialog" aria-label="Birthday invitation entry">
          <div className="ka-opening-card">
            <div className="ka-kuromi-sprite-wrap">
              <div
                ref={spriteRef}
                className="ka-kuromi-sprite"
                style={{ backgroundImage: `url(${danceSheet})` }}
                aria-hidden="true"
              />
            </div>
            <h1 className="ka-splash-title">Kaylin Ann's<br />7th Birthday!</h1>
            <p className="ka-splash-sub">{UI_EMOJI.sparkle} Cartoon Kuromi Theme {UI_EMOJI.sparkle}</p>
            <button className="ka-open-btn" onClick={playOpeningAnimation} onTouchStart={playOpeningAnimation}>Click to open invitation</button>
            <div className="ka-splash-stars" aria-hidden="true">
              <span className="ka-decor ka-decor-star-sm  ka-decor-pulse"  style={{animationDelay:'0s'}}   />
              <span className="ka-decor ka-decor-heart-sm ka-decor-float"  style={{animationDelay:'0.5s'}} />
              <span className="ka-decor ka-decor-heart    ka-decor-pulse"  style={{animationDelay:'1s'}}   />
              <span className="ka-decor ka-decor-heart-sm ka-decor-float"  style={{animationDelay:'1.5s'}} />
              <span className="ka-decor ka-decor-star-sm  ka-decor-pulse"  style={{animationDelay:'0.3s'}} />
            </div>
          </div>
        </div>
      )}

      {/* -- MAIN PAGE ------------------------------------------------ */}
      {!splashVisible && (
        <div className="ka-page">

          {/* HERO */}
          <header id="home" className="ka-hero">
            {/* Floating sprite decor */}
            <div className="ka-hero-decor" aria-hidden="true">
              <span className="ka-decor ka-decor-heart ka-decor-float"       style={{top:'10%',left:'3%'}} />
              <span className="ka-decor ka-decor-heart-sm ka-decor-float2"   style={{top:'32%',left:'1.5%',animationDelay:'1.3s'}} />
              <span className="ka-decor ka-decor-sparkle ka-decor-pulse"     style={{top:'7%',left:'21%',animationDelay:'0.4s'}} />
              <span className="ka-decor ka-decor-sparkle-sm ka-decor-pulse"  style={{top:'48%',right:'3%',animationDelay:'1.7s'}} />
              <span className="ka-decor ka-decor-star-cl ka-decor-float"     style={{top:'5%',right:'5%',animationDelay:'0.9s'}} />
              <span className="ka-decor ka-decor-hearts-cl ka-decor-float2" style={{bottom:'22%',left:'4%',animationDelay:'2.2s'}} />
              <span className="ka-decor ka-decor-dots ka-decor-float"        style={{top:'64%',right:'6%',animationDelay:'0.6s'}} />
            </div>
            <div className="ka-hero-grid">

              {/* Copy */}
              <div className="ka-hero-copy">                <h1 className="ka-hero-h1">Kaylin Ann <span>Dela Cruz</span></h1>
                <p className="ka-subtitle">
                  You are invited to a cute, magical, and playful birthday celebration filled with cupcakes,
                  balloons, gifts, wishes, lollipops, and sweet memories for our lovely celebrant.
                </p>
                <div className="ka-hero-actions">
                  <button className="ka-btn ka-btn-primary" onClick={() => scrollTo('rsvp')}>{`Send RSVP ${UI_EMOJI.message}`}</button>
                </div>
                <div className="ka-event-pills">
                  {[
                    ['Celebrant',  'Kaylin Ann Dela Cruz'],
                    ['Event Type', 'Birthday for Kids'],
                    ['Theme',      'Cartoon Kuromi Party'],
                    ['Location',   'Jollibee Sabang, Naic Highway'],
                  ].map(([label, val]) => (
                    <div key={label} className="ka-pill-card">
                      <small>{label}</small>
                      <strong>{val}</strong>
                    </div>
                  ))}
                </div>
              </div>

              {/* Photo stage */}
              <div className="ka-photo-stage">
                <div className="ka-moon"      aria-hidden="true" />
                <div className="ka-balloon ka-balloon-1" aria-hidden="true" />
                <div className="ka-balloon ka-balloon-2" aria-hidden="true" />
                <div className="ka-balloon ka-balloon-3" aria-hidden="true" />

                <div className="ka-photo-card">
                  <span className="ka-decor ka-decor-bow-pink ka-photo-bow-tl ka-decor-float2" aria-hidden="true" />
                                    <div className="ka-kuromi-hero-wrap" aria-hidden="true">
                    <div
                      ref={heroSpriteRef}
                      className="ka-kuromi-hero-sprite"
                      style={{ backgroundImage: `url(${kuromSheet})` }}
                    />
                  </div>
                  <div className="ka-photo-frame">
                    <img src={kaylinPhoto} alt="Kaylin Ann Dela Cruz birthday photo" />
                    <img src={kaylinCalig} alt="Kaylin Ann" className="ka-photo-calig" />
                    <p className="ka-photo-date">May 23, 2026</p>
                  </div>
                </div>
              </div>

            </div>
          </header>

          {/* COUNTDOWN */}
          <section className="ka-section">
            <div className="ka-container">
              <div className="ka-countdown-card">
                <div className="ka-countdown-head" style={{position:'relative'}}>
                  <span className="ka-decor ka-decor-star-sm ka-decor-pulse" style={{position:'absolute',left:'8px',top:'8px',animationDelay:'0s',opacity:0.7}} aria-hidden="true" />
                  <span className="ka-decor ka-decor-star-sm ka-decor-pulse" style={{position:'absolute',right:'8px',top:'8px',animationDelay:'1s',opacity:0.7}} aria-hidden="true" />
                  <div className="ka-tag">Countdown</div>
                  <h2 className="ka-section-h2">The magic starts soon</h2>
                  <p className="ka-section-desc">Every second brings us closer to the celebration!</p>
                </div>
                <div className="ka-countdown-row">
                  {[
                    { num: countdown.days,    label: 'Days'    },
                    { num: countdown.hours,   label: 'Hours'   },
                    { num: countdown.minutes, label: 'Minutes' },
                    { num: countdown.seconds, label: 'Seconds' },
                  ].map(({ num, label }) => (
                    <div key={label} className="ka-time-box">
                      <span className="ka-time-num">{pad(num)}</span>
                      <span className="ka-time-label">{label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* DETAILS */}
          <section id="details" className="ka-section">
            <div className="ka-container">
              <div className="ka-section-title" style={{position:'relative'}}>
                <span className="ka-decor ka-decor-bow-yellow ka-decor-float2" style={{position:'absolute',top:'-8px',right:'0',opacity:0.85,animationDelay:'0.5s'}} aria-hidden="true" />
                <div className="ka-tag">Party Details</div>
                <h2 className="ka-section-h2">Come celebrate with us</h2>
                <p className="ka-section-desc">
                  A cozy kids' birthday party with a cute purple-and-black Kuromi-inspired design,
                  playful animations, and sweet interactive moments.
                </p>
              </div>
              <div className="ka-details-grid">
                <div className="ka-detail-card">
                  <div className="ka-detail-icon-box">{UI_EMOJI.pin}</div>
                  <h3>Venue</h3>
                  <p>Jollibee Sabang, Naic Highway. Tap below to open maps.</p>
                  <br />
                  <a
                    className="ka-btn ka-btn-secondary"
                    href="https://www.google.com/maps/search/?api=1&query=Jollibee+Sabang+Naic+Highway"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize:'12px', padding:'9px 16px' }}
                  >
                    {`Open Map ${UI_EMOJI.map}`}
                  </a>
                </div>
                <div className="ka-detail-card">
                  <div className="ka-detail-icon-box">{UI_EMOJI.bow}</div>
                  <h3>Birthday Theme</h3>
                  <p>Cartoon Kuromi-inspired theme with purple ribbons, black accents, cute sparkles, and kid-friendly fun.</p>
                </div>
                <div className="ka-detail-card">
                  <div className="ka-detail-icon-box">{UI_EMOJI.party}</div>
                  <h3>Special Program</h3>
                  <p>Includes 7 cupcakes, 7 gifts, 7 wishes, 7 blue bills, 7 roses, 7 balloons, and 7 lollipops.</p>
                </div>
              </div>
            </div>
          </section>

          {/* 7 TREASURES */}
          <section id="program" className="ka-section">
            <div className="ka-container">
              <div className="ka-section-title">
                <div className="ka-tag">7 Treasures</div>
                <h2 className="ka-section-h2">Birthday program list</h2>
                <p className="ka-section-desc">
                  Tap each category to view the special names in Kaylin's birthday celebration.
                </p>
              </div>

              <div className="ka-program-tabs" role="tablist">
                {TRADITIONS.map(t => (
                  <button
                    key={t.id}
                    role="tab"
                    aria-selected={activeTab === t.id}
                    className={`ka-tab-btn${activeTab === t.id ? ' active' : ''}`}
                    onClick={() => setActiveTab(t.id)}
                  >
                    {t.label}
                  </button>
                ))}
              </div>

              {activeTrad && (
                <div className="ka-program-panel" role="tabpanel" key={activeTrad.id}>
                  <div className="ka-names-grid">
                    {activeTrad.names.map((name, idx) => (
                      <div
                        key={idx}
                        className="ka-name-card"
                        role="button"
                        tabIndex={0}
                        onClick={() => showNameModal(activeTrad.emoji, name)}
                        onKeyDown={(e) => e.key === 'Enter' && showNameModal(activeTrad.emoji, name)}
                      >
                        <span className="ka-name-num">{idx + 1}</span>
                        <div>
                          <span className="ka-name-emoji">{activeTrad.emoji}</span>
                          <span className="ka-name-text">{name}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* MESSAGE */}
          <section id="message" className="ka-section ka-section-flush">
            <div className="ka-gallery-grid">
                <div className="ka-gallery-photo">
                  <img src={kaylinPhoto} alt="Kaylin Ann Dela Cruz" />
                </div>
                <div className="ka-message-right">
                  <h2 className="ka-message-h2">A birthday wish<br />for Kaylin</h2>
                  <span className="ka-message-accent" aria-hidden="true" />
                  <p className="ka-message-p">
                    May your special day be filled with laughter, love, sweet treats, and magical memories.
                    Keep shining with your bright smile and beautiful heart.
                  </p>
                  <p className="ka-message-p">
                    Today is all about celebrating you, Kaylin Ann Dela Cruz, our little star with a magical birthday story.
                  </p>
                  <div className="ka-wish-box">
                    {`With love, joy, and purple sparkle ${UI_EMOJI.sparkle} Happy Birthday, Kaylin! ${UI_EMOJI.heart}`}
                  </div>
                </div>
            </div>
          </section>

          {/* RSVP */}
          <section id="rsvp" className="ka-section">
            <div className="ka-container">
              <div className="ka-rsvp-card">
                <div className="ka-rsvp-copy">
                  <div className="ka-tag" style={{ marginBottom: '12px' }}>RSVP</div>
                  <h2>Will you join Kaylin's party?</h2>
                  <p>
                    Fill out this quick form so we can prepare the best celebration for Kaylin!
                    {` Your attendance means the world to her. ${UI_EMOJI.heart}`}
                  </p>
                  <button className="ka-btn ka-btn-secondary" onClick={() => launchConfetti()}>
                    {`Celebrate Now ${UI_EMOJI.party}`}
                  </button>
                </div>

                <div>
                  {rsvpDone ? (
                    <div className="ka-rsvp-success">
                      <span className="ka-rsvp-success-emoji">{UI_EMOJI.celebrate}</span>
                      <h3>RSVP Received!</h3>
                      <p>{`Thank you! We're so excited to celebrate with you. Kaylin can't wait! ${UI_EMOJI.party} ${UI_EMOJI.sparkle}`}</p>
                    </div>
                  ) : (
                    <form className="ka-rsvp-form" onSubmit={handleRsvpSubmit} noValidate>
                      {rsvpError && <div className="ka-rsvp-error" role="alert">{rsvpError}</div>}

                      <input
                        className="ka-rsvp-input" type="text" name="name"
                        placeholder="Your name" value={rsvpData.name}
                        onChange={onRsvpChange} autoComplete="name"
                      />
                      <select
                        className="ka-rsvp-select" name="status"
                        value={rsvpData.status} onChange={onRsvpChange}
                      >
                        <option value="">Will you attend?</option>
                        <option value="yes">{`Yes, I will attend! ${UI_EMOJI.party}`}</option>
                        <option value="no">{`Sorry, I can't attend ${UI_EMOJI.sad}`}</option>
                      </select>
                      <input
                        className="ka-rsvp-input" type="number" name="guests"
                        min="1" max="10" placeholder="Number of guests"
                        value={rsvpData.guests} onChange={onRsvpChange}
                      />
                      <textarea
                        className="ka-rsvp-textarea" name="message"
                        placeholder={`Message for Kaylin ${UI_EMOJI.heart}`}
                        value={rsvpData.message} onChange={onRsvpChange}
                      />
                      <button
                        type="submit"
                        className="ka-btn ka-btn-primary"
                        disabled={rsvpLoading}
                        style={{ width: '100%', justifyContent: 'center' }}
                      >
                        {rsvpLoading ? `${UI_EMOJI.message} Sending...` : `Submit RSVP ${UI_EMOJI.message}`}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </section>

          {/* FOOTER */}
          <footer className="ka-footer-bottom">
            <div className="ka-footer-ribbon" aria-hidden="true">
              {[...Array(5)].map((_,i) => <span key={i} className="ka-decor ka-decor-bow-pink-sm ka-decor-pulse" style={{animationDelay:`${i*0.4}s`,opacity:0.7}} />)}
            </div>
            <img src={logicaLogo} alt="Logica Technology" className="ka-footer-logo" />
            <p className="ka-footer-copy">
              {`Made with ${UI_EMOJI.heart} for Kaylin Ann Dela Cruz's Birthday ${UI_EMOJI.sparkle} Cartoon Kuromi Theme`}
              {' | '}
              <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">
                Logica Technology
              </a>
            </p>
          </footer>

          {/* MUSIC BUTTON */}
          <button
            className="ka-music-btn"
            onClick={toggleMusic}
            aria-label={musicOn ? 'Mute music' : 'Play party music'}
            title="Toggle party sound"
          >
            {musicOn ? UI_EMOJI.musicOn : UI_EMOJI.musicOff}
          </button>

          {/* MODAL */}
          {modal && (
            <div
              className="ka-modal-overlay"
              role="dialog"
              aria-modal="true"
              onClick={(e) => { if (e.target === e.currentTarget) setModal(null); }}
            >
              <div className="ka-modal-card">
                <div className="ka-modal-icon">{modal.icon}</div>
                <h3>{modal.title}</h3>
                <p>{modal.text}</p>
                <button
                  className="ka-btn ka-modal-close-btn"
                  onClick={() => setModal(null)}
                  style={{ width: '100%', justifyContent: 'center' }}
                >
                  {`Close ${UI_EMOJI.sparkle}`}
                </button>
              </div>
            </div>
          )}

        </div>
      )}
    </div>
  );
}
